/* DOMNO. rewards — ring picker gesture fix (9 Sep 2026)

   Dom, 8 Sep: "when you're swiping through and you're scrolling on mobile, if you just touch one
   of the product images, it automatically changes it to the one at the bottom. It's very
   sensitive."

   THE CAUSE, in domno-portal.js:
     window.dpTE = function(e, idx){
       var dx = e.changedTouches[0].clientX - tx;
       e.preventDefault();
       if (Math.abs(dx) > 30) { shift(...); } else { dpSel(idx); }
     };
   Two faults. 30px of horizontal drift is nothing — a normal tap wobbles more than that on a
   moving hand. And it only ever measured X, so dragging the grid VERTICALLY to scroll still
   registered whatever sideways drift came with it and flipped the photo.

   THE FIX, applied by overriding dpTS/dpTE after domno-portal.js has defined them:
     • a swipe must travel >= 60px horizontally, AND
     • be more horizontal than vertical (1.5x), AND
     • anything mostly vertical is left completely alone so the grid scrolls normally.
   Anything that is neither is treated as a tap and opens the size sheet, which is what a
   customer means by touching a photo.

   Loaded AFTER domno-portal.js. It replaces the two globals rather than editing the 30KB
   drawer snippet, so Charlie's file stays as he wrote it.
   Numbers are a starting point — tune SWIPE_MIN_PX / SWIPE_RATIO if it still feels off on a
   real phone. */
(function(){
  var SWIPE_MIN_PX = 60;   /* how far sideways before it counts as a swipe at all */
  var SWIPE_RATIO  = 1.5;  /* how much more horizontal than vertical it has to be */

  var sx = 0, sy = 0, tracking = false;

  function install(){
    if (typeof window.dpSel !== 'function') return false;   /* portal js not up yet */

    window.dpTS = function(e){
      try{
        var t = e.changedTouches[0];
        sx = t.clientX; sy = t.clientY; tracking = true;
      }catch(err){ tracking = false; }
    };

    window.dpTE = function(e, idx){
      if(!tracking){ return; }
      tracking = false;
      var t, dx, dy, ax, ay;
      try{
        t  = e.changedTouches[0];
        dx = t.clientX - sx;
        dy = t.clientY - sy;
      }catch(err){ return; }
      ax = Math.abs(dx); ay = Math.abs(dy);

      /* Mostly vertical: they are scrolling the grid. Do nothing at all, and crucially do NOT
         preventDefault, or the page stops scrolling under their finger. */
      if (ay > ax) return;

      /* Sideways, and far enough, and clearly sideways rather than a diagonal wobble. */
      if (ax >= SWIPE_MIN_PX && ax > ay * SWIPE_RATIO) {
        e.preventDefault();
        var pimg = e.currentTarget;
        var shots = pimg.getElementsByClassName('shot');
        var dots  = pimg.querySelectorAll('.dots span');
        if(!shots.length) return;
        var cur = 0;
        for (var k = 0; k < shots.length; k++) if (shots[k].classList.contains('on')) cur = k;
        var next = (cur + (dx < 0 ? 1 : -1) + shots.length) % shots.length;
        for (var j = 0; j < shots.length; j++){
          shots[j].classList.toggle('on', j === next);
          if (dots[j]) dots[j].classList.toggle('on', j === next);
        }
        return;
      }

      /* Everything else is a tap on the photo, which means "show me this ring". */
      e.preventDefault();
      try{ window.dpSel(idx); }catch(err){}
    };

    return true;
  }

  if (!install()) {
    var n = 0;
    var iv = setInterval(function(){
      n++;
      if (install() || n > 60) clearInterval(iv);
    }, 100);
  }
})();
